import { ofType } from 'redux-observable';
import { switchMap, catchError, map } from 'rxjs/operators';

import { actions } from '@ezugi/bootstrap';
import { getPayouts, handlePayoutsError } from '@ezugi/bootstrap/src/util/getPayouts';

import { formatPayouts } from './utils';

const {
  configActions: { config },
  authActions: { auth },
} = actions;

function payoutsEpic(action$, state$) {
  return action$.pipe(
    ofType(auth.success),
    switchMap(() => getPayouts(state$.value)),
    map(({ result: { payouts } = {} }) => config.update({ payouts: formatPayouts(payouts) })),
    catchError(handlePayoutsError)
  );
}

export default payoutsEpic;
